import { MadoAccountObject } from "@libs/types/src/mado/object-type/account.object";

export function madoAccountToDropdownOptionString(account?: MadoAccountObject) {
    return `${account?.code} - ${account?.name}`
}
